import clsx from "clsx";

import { Badge } from "@components/v2";
import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
}

const CustomerTypeCellFormatter = <TData,>(props: TableCellProps<TData>) => {
  return (
    <div
      className={clsx(
        "px-4 py-2.5 bg-inherit font-mono",
        "text-sm text-v2-action font-medium tracking-[0.28px]",
        "flex justify-center items-center h-full",
      )}
      title={String(props.cell.getValue())}
    >
      <Badge
        variant="notice"
        emphasis={props.cell.getValue() === "first_time" ? true : false}
      >
        {props.cell.getValue() === "first_time" ? "First-Time" : "Returning"}
      </Badge>
    </div>
  );
};

export default CustomerTypeCellFormatter;
